import createIcon from '../../createIcon';

/**
 * @component @name LockReset
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNSAzQzguNTMgMyA0LjUgNy4wMyA0LjUgMTJIMS41TDUuNSAxNkw5LjUgMTJINi41QzYuNSA4LjE0IDkuNjQgNSAxMy41IDVDMTcuMzYgNSAyMC41IDguMTQgMjAuNSAxMkMyMC41IDE1Ljg2IDE3LjM2IDE5IDEzLjUgMTlDMTEuNiAxOSA5Ljg4IDE4LjI0IDguNjIgMTcuMDFMNy4yIDE4LjQyQzguODIgMjAuMDEgMTEuMDUgMjEgMTMuNSAyMUMxOC40NyAyMSAyMi41IDE2Ljk3IDIyLjUgMTJDMjIuNSA3LjAzIDE4LjQ3IDMgMTMuNSAzWk0xNS41IDExVjEwQzE1LjUgOC45IDE0LjYgOCAxMy41IDhDMTIuNCA4IDExLjUgOC45IDExLjUgMTBWMTFDMTAuOTUgMTEgMTAuNSAxMS40NSAxMC41IDEyVjE1QzEwLjUgMTUuNTUgMTAuOTUgMTYgMTEuNSAxNkgxNS41QzE2LjA1IDE2IDE2LjUgMTUuNTUgMTYuNSAxNVYxMkMxNi41IDExLjQ1IDE2LjA1IDExIDE1LjUgMTFaTTE0LjUgMTFIMTIuNVYxMEMxMi41IDkuNDUgMTIuOTUgOSAxMy41IDlDMTQuMDUgOSAxNC41IDkuNDUgMTQuNSAxMFYxMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LockReset = createIcon('LockReset', [
  [
    'path',
    {
      d: 'M13.5 3C8.53 3 4.5 7.03 4.5 12H1.5L5.5 16L9.5 12H6.5C6.5 8.14 9.64 5 13.5 5C17.36 5 20.5 8.14 20.5 12C20.5 15.86 17.36 19 13.5 19C11.6 19 9.88 18.24 8.62 17.01L7.2 18.42C8.82 20.01 11.05 21 13.5 21C18.47 21 22.5 16.97 22.5 12C22.5 7.03 18.47 3 13.5 3ZM15.5 11V10C15.5 8.9 14.6 8 13.5 8C12.4 8 11.5 8.9 11.5 10V11C10.95 11 10.5 11.45 10.5 12V15C10.5 15.55 10.95 16 11.5 16H15.5C16.05 16 16.5 15.55 16.5 15V12C16.5 11.45 16.05 11 15.5 11ZM14.5 11H12.5V10C12.5 9.45 12.95 9 13.5 9C14.05 9 14.5 9.45 14.5 10V11Z',
      key: '5duh86',
    },
  ],
]);

export default LockReset;
